import { createAction } from '@reduxjs/toolkit'

import type { PaginatedResponse } from 'api/Cerebro/types'
import type { OrganizationGroup } from 'types'

// fetch organization group
export const fetchOrganizationGroupSuccess = createAction<OrganizationGroup>(
    'FETCH_ORGANIZATION_GROUP_SUCCESS'
)

// fetch organization groups
export const fetchOrganizationGroupsSuccess = createAction<
    PaginatedResponse<OrganizationGroup>
>('FETCH_ORGANIZATION_GROUPS_SUCCESS')
